// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/images/caret.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wnRheSYJ6gO9jP {
  margin: 4em 1em;
  color: var(--ds-text-subtle, #44546f);
  text-align: center;
}
.EfOr0jR4aCxNXX {
  margin: 0.5em 0 0;
  padding: 0;
  list-style: none;
}
.pKFUeZ2JLE_AB6 {
  display: inline-block;
  margin: 0 0.4em;
}
.jCSHKL0sRPef6r,
.jCSHKL0sRPef6r:visited {
  color: var(--ds-text-subtle, #44546f);
}
.jCSHKL0sRPef6r:hover,
.jCSHKL0sRPef6r:visited:hover {
  color: var(--ds-text, #172b4d);
}
.AeH3vZ6VhMjJmm {
  margin: 0.5em 0;
}
.PU_uwVaIArSu4d {
  display: inline-block;
  width: 150px;
  margin-right: 8px;
  vertical-align: top;
}
.YEUAfQnbkded30 {
  display: inline-block;
  position: relative;
}
.YEUAfQnbkded30::after {
  content: '';
  position: absolute;
  top: 45%;
  right: 16px;
  box-sizing: content-box;
  width: 10px;
  height: 16px;
  margin: 0;
  padding: 0;
  transform: translateY(-50%) rotate(90deg);
  border: 0;
  background: var(--ds-background-neutral, #091e420f) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-color: transparent;
  background-position: center;
}
.YEUAfQnbkded30 select {
  display: inline-block;
  padding: 8px;
  border: 2px solid var(--ds-border, #091e4224);
  border-radius: 3px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 16px;
  font-weight: 400;
  appearance: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `wnRheSYJ6gO9jP`,
	"footerList": `EfOr0jR4aCxNXX`,
	"footerListItem": `pKFUeZ2JLE_AB6`,
	"footerListItemLink": `jCSHKL0sRPef6r`,
	"footerDetail": `AeH3vZ6VhMjJmm`,
	"atlassianLogo": `PU_uwVaIArSu4d`,
	"languagePicker": `YEUAfQnbkded30`
};
export default ___CSS_LOADER_EXPORT___;
